/* AMARA EDITORIAL — Theme JS v2 */
(function () {
  'use strict';

  var root = function () {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  };

  var money = function (cents) {
    var fmt = (window.AmaraTheme && window.AmaraTheme.moneyFormat) || '{{amount_with_comma_separator}} €';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (fmt.indexOf('comma_separator') > -1) return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, int + ',' + parts[1]);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, int + ',' + parts[1]);
  };

  var store = {
    get: function (k, fb) {
      try { return JSON.parse(window.localStorage.getItem(k)) || fb; } catch (e) { return fb; }
    },
    set: function (k, v) {
      try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
    }
  };

  var lockScroll = function (on) {
    document.body.style.overflow = on ? 'hidden' : '';
  };

  /* ---------- Carousel ---------- */
  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-carou]').forEach(function (c) {
      if (c.dataset.ready) return;
      c.dataset.ready = '1';
      var track = c.querySelector('[data-carou-track]');
      var prev = c.querySelector('[data-carou-prev]');
      var next = c.querySelector('[data-carou-next]');
      if (!track) return;
      var step = function () {
        var first = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap || '3') || 3;
        return first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      };
      var sync = function () {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------- Ankündigungsleiste ---------- */
  function initAnnouncement() {
    document.querySelectorAll('[data-ann]').forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      var row = bar.querySelector('[data-ann-row]');
      if (!row) return;

      var items = [].slice.call(row.children);
      if (!items.length) return;

      var small = window.matchMedia('(max-width: 720px)');
      var at = 0;
      var timer = null;

      var slots = function () {
        return Math.min(small.matches ? 1 : 3, items.length);
      };

      var show = function () {
        var n = slots();
        items.forEach(function (i) { i.style.display = 'none'; i.classList.remove('is-on'); });
        for (var k = 0; k < n; k++) {
          var el = items[(at + k) % items.length];
          el.style.display = '';
          el.classList.add('is-on');
          el.style.animation = 'none';
          void el.offsetWidth;
          el.style.animation = '';
        }
      };

      var secs = parseInt(bar.getAttribute('data-rotate') || '5', 10);

      var cycle = function () {
        window.clearInterval(timer);
        at = 0;
        show();
        if (secs > 0 && items.length > slots()) {
          timer = window.setInterval(function () {
            at = (at + slots()) % items.length;
            show();
          }, secs * 1000);
        }
      };

      cycle();
      if (small.addEventListener) small.addEventListener('change', cycle);
      else if (small.addListener) small.addListener(cycle);
    });
  }

  /* ---------- Header ---------- */
  function initHeaderScroll() {
    var head = document.querySelector('[data-header]');
    if (!head || !head.classList.contains('head--over')) return;
    var sync = function () { head.classList.toggle('is-solid', window.scrollY > 40); };
    window.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  /* ---------- Mobile-Nav ---------- */
  function initMobileNav() {
    var nav = document.querySelector('[data-mnav]');
    if (!nav) return;
    var open = function () { nav.classList.add('is-open'); lockScroll(true); };
    var close = function () { nav.classList.remove('is-open'); lockScroll(false); };
    document.querySelectorAll('[data-mnav-open]').forEach(function (b) { b.addEventListener('click', open); });
    nav.querySelectorAll('[data-mnav-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Filter: Dropdowns, Drawer, Auto-Submit ---------- */
  function initFacets() {
    document.querySelectorAll('[data-facet]').forEach(function (f) {
      if (f.dataset.ready) return;
      f.dataset.ready = '1';
      var btn = f.querySelector('[data-facet-btn]');
      if (!btn) return;
      var inDrawer = !!f.closest('[data-fdrawer]');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var was = f.classList.contains('is-open');
        if (!inDrawer) {
          document.querySelectorAll('[data-facet]').forEach(function (o) {
            if (!o.closest('[data-fdrawer]')) {
              o.classList.remove('is-open');
              var b = o.querySelector('[data-facet-btn]');
              if (b) b.setAttribute('aria-expanded', 'false');
            }
          });
        }
        f.classList.toggle('is-open', !was);
        btn.setAttribute('aria-expanded', String(!was));
      });
      if (!inDrawer) f.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    if (!document.body.dataset.facetDoc) {
      document.body.dataset.facetDoc = '1';
      document.addEventListener('click', function () {
        document.querySelectorAll('[data-facet]').forEach(function (o) {
          if (o.closest('[data-fdrawer]')) return;
          o.classList.remove('is-open');
          var b = o.querySelector('[data-facet-btn]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
      });
    }

    document.querySelectorAll('[data-facet-form]').forEach(function (form) {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      form.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'number') return;
        form.submit();
      });
    });

    var fd = document.querySelector('[data-fdrawer]');
    if (fd && !fd.dataset.ready) {
      fd.dataset.ready = '1';
      var open = function () { fd.classList.add('is-open'); lockScroll(true); };
      var close = function () { fd.classList.remove('is-open'); lockScroll(false); };
      document.querySelectorAll('[data-fdrawer-open]').forEach(function (b) { b.addEventListener('click', open); });
      fd.querySelectorAll('[data-fdrawer-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
  }

  /* ---------- Mehr laden ---------- */
  function initLoadMore() {
    document.querySelectorAll('[data-more]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-more');
        if (!url) return;
        var section = btn.closest('.shopify-section') || document;
        var sid = section.id ? section.id.replace('shopify-section-', '') : '';
        var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sid;
        var label = btn.textContent;
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = 'Lädt …';

        fetch(fetchUrl)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var freshGrid = doc.querySelector('[data-grid]');
            var grid = document.querySelector('[data-grid]');
            if (freshGrid && grid) {
              while (freshGrid.firstElementChild) grid.appendChild(freshGrid.firstElementChild);
            }
            var freshBtn = doc.querySelector('[data-more]');
            var wrap = btn.closest('[data-more-wrap]');
            if (freshBtn) {
              btn.setAttribute('data-more', freshBtn.getAttribute('data-more'));
              btn.removeAttribute('aria-disabled');
              btn.textContent = label;
            } else {
              btn.remove();
            }
            var freshCount = doc.querySelector('.more__count');
            var count = wrap ? wrap.querySelector('.more__count') : null;
            if (freshCount && count) count.textContent = freshCount.textContent;
            initWishState();
          })
          .catch(function () {
            btn.removeAttribute('aria-disabled');
            btn.textContent = label;
          });
      });
    });
  }

  /* ---------- Such-Overlay mit Vorschlägen ---------- */
  function initSearch() {
    var box = document.querySelector('[data-search]');
    if (!box || box.dataset.ready) return;
    box.dataset.ready = '1';

    var input = box.querySelector('[data-search-input]');
    var out = box.querySelector('[data-search-results]');
    var quick = box.querySelector('[data-search-quick]');
    var timer = null;
    var last = '';

    var open = function () {
      box.hidden = false;
      lockScroll(true);
      window.setTimeout(function () { if (input) input.focus(); }, 60);
    };
    var close = function () {
      box.hidden = true;
      lockScroll(false);
    };

    document.querySelectorAll('[data-search-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    box.querySelectorAll('[data-search-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });

    if (!input || !out) return;

    var run = function (q) {
      var url = root() + 'search/suggest?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search' +
        '&resources[type]=product,collection,page,article&resources[limit]=5';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-ps-results]');
          out.innerHTML = fresh ? fresh.innerHTML : '';
          if (quick) quick.hidden = true;
        })
        .catch(function () {});
    };

    input.addEventListener('input', function () {
      var q = input.value.trim();
      window.clearTimeout(timer);
      if (q.length < 2) {
        out.innerHTML = '';
        if (quick) quick.hidden = false;
        last = '';
        return;
      }
      if (q === last) return;
      timer = window.setTimeout(function () { last = q; run(q); }, 240);
    });
  }

  /* ---------- Cart-Drawer und Warenkorbseite ---------- */
  var Cart = {
    el: null,
    isPage: false,
    init: function () {
      Cart.el = document.querySelector('[data-drawer]');
      Cart.isPage = !!document.querySelector('[data-cart-page]');

      document.addEventListener('click', function (e) {
        var open = e.target.closest('[data-cart-open]');
        if (open && Cart.el) { e.preventDefault(); Cart.open(); return; }
        if (e.target.closest('[data-drawer-close]')) { Cart.close(); return; }

        var plus = e.target.closest('[data-qty-plus]');
        var minus = e.target.closest('[data-qty-minus]');
        var rm = e.target.closest('[data-cart-remove]');
        if (plus || minus || rm) {
          var row = (plus || minus || rm).closest('[data-line]');
          if (!row) return;
          e.preventDefault();
          var line = parseInt(row.dataset.line, 10);
          var cur = parseInt(row.dataset.qty, 10) || 1;
          var q = rm ? 0 : (plus ? cur + 1 : Math.max(0, cur - 1));
          row.style.opacity = '.5';
          Cart.change(line, q);
          return;
        }

        var qa = e.target.closest('[data-quick-add]');
        if (qa) {
          e.preventDefault();
          Cart.add(qa.getAttribute('data-quick-add'), 1, qa);
        }
      });

      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });

      document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var idEl = form.querySelector('[name="id"]');
          var qEl = form.querySelector('[name="quantity"]');
          if (!idEl) return;
          Cart.add(idEl.value, qEl ? (parseInt(qEl.value, 10) || 1) : 1, form.querySelector('[data-atc]'));
        });
      });
    },
    open: function () { if (Cart.el) { Cart.el.classList.add('is-open'); lockScroll(true); } },
    close: function () {
      if (Cart.el) Cart.el.classList.remove('is-open');
      lockScroll(false);
    },
    add: function (id, qty, btn) {
      var label = btn ? btn.textContent : '';
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Wird hinzugefügt …'; }
      return fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status && data.status >= 400) throw new Error(data.description || 'error');
          return Cart.refresh();
        })
        .then(function () { if (!Cart.isPage) Cart.open(); })
        .catch(function () {
          if (btn) { btn.textContent = 'Nicht verfügbar'; }
        })
        .finally(function () {
          if (btn) {
            btn.removeAttribute('aria-disabled');
            window.setTimeout(function () { if (label) btn.textContent = label; }, 900);
          }
        });
    },
    change: function (line, qty) {
      return fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return Cart.refresh(); });
    },
    refresh: function () {
      var jobs = [Cart.refreshDrawer()];
      if (Cart.isPage) jobs.push(Cart.refreshPage());
      return Promise.all(jobs);
    },
    refreshDrawer: function () {
      if (!Cart.el) return Promise.resolve();
      return fetch(root() + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-drawer-inner]');
          var mount = document.querySelector('[data-drawer-inner]');
          if (fresh && mount) mount.innerHTML = fresh.innerHTML;
          var cnt = doc.querySelector('[data-cart-count]');
          if (cnt) {
            document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cnt.textContent; });
          }
        })
        .catch(function () {});
    },
    refreshPage: function () {
      return fetch(window.location.href)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.cart');
          var mount = document.querySelector('.cart');
          if (fresh && mount) {
            mount.innerHTML = fresh.innerHTML;
            Cart.isPage = !!document.querySelector('[data-cart-page]');
          }
        })
        .catch(function () { window.location.reload(); });
    }
  };

  /* ---------- Produktseite: Varianten ---------- */
  function initVariants() {
    document.querySelectorAll('[data-variants]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';

      var json = box.querySelector('[data-variant-json]');
      var data = {};
      try { data = JSON.parse(json.textContent); } catch (e) { return; }
      if (!data.variants || !data.variants.length) return;

      var form = box.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('[name="id"]') : null;
      var priceNow = box.querySelector('[data-price-now]');
      var priceWas = box.querySelector('[data-price-was]');
      var priceOff = box.querySelector('[data-price-off]');
      var stockEl = box.querySelector('[data-stock]');
      var skuEl = box.querySelector('[data-sku]');
      var barPrice = document.querySelector('[data-bar-price]');
      var atc = form ? form.querySelector('[data-atc]') : null;
      var lowStock = parseInt(box.getAttribute('data-low-stock') || '5', 10);

      var groups = [].slice.call(box.querySelectorAll('[data-opt-group]'));
      var selected = groups.map(function (g) {
        var on = g.querySelector('.is-on');
        return on ? on.dataset.value : null;
      });
      if (!groups.length) selected = data.variants[0].options.slice();

      function match() {
        return data.variants.filter(function (v) {
          return selected.every(function (s, i) { return s === null || v.options[i] === s; });
        })[0];
      }

      function paint() {
        var v = match();
        if (!v) return;

        if (idInput) idInput.value = v.id;
        if (priceNow) {
          priceNow.textContent = money(v.price);
          priceNow.classList.toggle('card__now--sale', !!(v.compare_at_price && v.compare_at_price > v.price));
        }
        if (barPrice) barPrice.textContent = money(v.price);
        if (priceWas) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceWas.textContent = money(v.compare_at_price);
            priceWas.hidden = false;
          } else { priceWas.hidden = true; }
        }
        if (priceOff) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceOff.textContent = '−' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
            priceOff.hidden = false;
          } else { priceOff.hidden = true; }
        }
        if (skuEl) skuEl.textContent = v.sku || '';

        if (stockEl) {
          if (!v.available) {
            stockEl.textContent = 'Zurzeit nicht verfügbar';
            stockEl.classList.remove('pdp__stock--ok');
            stockEl.hidden = false;
          } else if (lowStock > 0 && v.inventory > 0 && v.inventory <= lowStock) {
            stockEl.textContent = 'Nur noch ' + v.inventory + ' auf Lager';
            stockEl.classList.remove('pdp__stock--ok');
            stockEl.hidden = false;
          } else {
            stockEl.hidden = true;
          }
        }

        if (atc) {
          if (v.available) {
            atc.removeAttribute('aria-disabled');
            atc.textContent = 'In den Warenkorb';
          } else {
            atc.setAttribute('aria-disabled', 'true');
            atc.textContent = 'Ausverkauft';
          }
        }

        if (window.history && history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        }

        if (v.media_id) {
          var fig = document.querySelector('[data-media-id="' + v.media_id + '"]');
          if (fig) {
            var gal = fig.closest('[data-gal]');
            if (gal && getComputedStyle(gal).display === 'flex') {
              gal.scrollTo({ left: fig.offsetLeft - gal.offsetLeft, behavior: 'smooth' });
            } else {
              fig.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        }

        groups.forEach(function (g, gi) {
          g.querySelectorAll('[data-value]').forEach(function (b) {
            var probe = selected.slice();
            probe[gi] = b.dataset.value;
            var ok = data.variants.some(function (vv) {
              return probe.every(function (s, i) { return s === null || vv.options[i] === s; }) && vv.available;
            });
            b.classList.toggle('is-off', !ok);
          });
        });
      }

      box.querySelectorAll('[data-value]').forEach(function (b) {
        b.addEventListener('click', function () {
          var g = b.closest('[data-opt-group]');
          var gi = parseInt(g.dataset.optGroup, 10);
          g.querySelectorAll('[data-value]').forEach(function (o) { o.classList.remove('is-on'); });
          b.classList.add('is-on');
          selected[gi] = b.dataset.value;
          var lbl = g.querySelector('[data-opt-current]');
          if (lbl) lbl.textContent = b.dataset.value;
          paint();
        });
      });

      paint();
    });
  }

  /* ---------- Produktseite: Menge ---------- */
  function initQty() {
    document.querySelectorAll('[data-pdp-qty]').forEach(function (input) {
      if (input.dataset.ready) return;
      input.dataset.ready = '1';
      var wrap = input.closest('.qty');
      if (!wrap) return;
      var set = function (n) { input.value = Math.max(1, n); };
      var minus = wrap.querySelector('[data-pdp-minus]');
      var plus = wrap.querySelector('[data-pdp-plus]');
      if (minus) minus.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) + 1); });
    });
  }

  /* ---------- Produktseite: Galerie-Punkte ---------- */
  function initGallery() {
    document.querySelectorAll('[data-gal]').forEach(function (gal) {
      if (gal.dataset.ready) return;
      gal.dataset.ready = '1';
      var wrap = gal.parentElement;
      var dots = wrap ? wrap.querySelector('[data-gal-dots]') : null;
      var items = [].slice.call(gal.querySelectorAll('[data-gal-item]'));
      if (!dots || items.length < 2) return;

      dots.innerHTML = '';
      items.forEach(function (it, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'pdp__dot' + (i === 0 ? ' is-on' : '');
        d.setAttribute('aria-label', 'Bild ' + (i + 1));
        d.addEventListener('click', function () {
          gal.scrollTo({ left: it.offsetLeft - gal.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(d);
      });

      var sync = function () {
        var i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
        dots.querySelectorAll('.pdp__dot').forEach(function (d, di) {
          d.classList.toggle('is-on', di === i);
        });
      };
      gal.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    });
  }

  /* ---------- Produktseite: Sticky Kaufleiste ---------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-pbar]');
    var atc = document.querySelector('[data-atc]');
    if (!bar || !atc || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    bar.hidden = false;

    var btn = bar.querySelector('[data-bar-atc]');
    if (btn) {
      btn.addEventListener('click', function () {
        if (atc.getAttribute('aria-disabled') === 'true') {
          atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        atc.click();
      });
    }

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    }, { rootMargin: '0px' });
    io.observe(atc);
  }

  /* ---------- Größentabelle ---------- */
  function initSizeGuide() {
    var modal = document.querySelector('[data-guide]');
    if (!modal || modal.dataset.ready) return;
    modal.dataset.ready = '1';
    var open = function () { modal.hidden = false; lockScroll(true); };
    var close = function () { modal.hidden = true; lockScroll(false); };
    document.querySelectorAll('[data-guide-open]').forEach(function (b) { b.addEventListener('click', open); });
    modal.querySelectorAll('[data-guide-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  }

  /* ---------- Link kopieren ---------- */
  function initShare() {
    document.querySelectorAll('[data-share]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      btn.addEventListener('click', function () {
        var txt = btn.getAttribute('data-share');
        var done = function () {
          var ok = btn.parentElement ? btn.parentElement.querySelector('[data-share-ok]') : null;
          if (ok) {
            ok.hidden = false;
            window.setTimeout(function () { ok.hidden = true; }, 1800);
          }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(txt).then(done).catch(function () {});
        } else {
          var ta = document.createElement('textarea');
          ta.value = txt;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(ta);
        }
      });
    });
  }

  /* ---------- Merkliste ---------- */
  var WISH = 'amara:wish';

  function wishList() { return store.get(WISH, []); }

  function wishCount() {
    var n = wishList().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function initWishState() {
    var list = wishList();
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      b.classList.toggle('is-on', list.indexOf(b.getAttribute('data-wish')) > -1);
    });
  }

  function initWish() {
    wishCount();
    initWishState();
    if (document.body.dataset.wishDoc) return;
    document.body.dataset.wishDoc = '1';

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wish]');
      if (!b) return;
      e.preventDefault();
      var handle = b.getAttribute('data-wish');
      var list = wishList();
      var i = list.indexOf(handle);
      if (i > -1) list.splice(i, 1);
      else list.unshift(handle);
      store.set(WISH, list.slice(0, 60));
      b.classList.toggle('is-on', i === -1);
      wishCount();

      var grid = document.querySelector('[data-wish-grid]');
      if (grid && i > -1) {
        var card = b.closest('.card');
        var holder = card ? card.parentElement : null;
        if (holder && holder.parentElement === grid) holder.remove();
        else if (card && card.parentElement === grid) card.remove();
        renderWishEmpty();
      }
    });
  }

  function renderWishEmpty() {
    var grid = document.querySelector('[data-wish-grid]');
    var empty = document.querySelector('[data-wish-empty]');
    var total = document.querySelector('[data-wish-total]');
    if (!grid) return;
    var n = grid.children.length;
    if (empty) empty.hidden = n > 0;
    if (total) total.textContent = n > 0 ? n + (n === 1 ? ' Artikel' : ' Artikel') : '';
  }

  function initWishPage() {
    var grid = document.querySelector('[data-wish-grid]');
    if (!grid || grid.dataset.ready) return;
    grid.dataset.ready = '1';
    var list = wishList();
    if (!list.length) { renderWishEmpty(); return; }

    Promise.all(list.map(function (handle) {
      return fetch(root() + 'products/' + handle + '?section_id=card-product')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (parts) {
      parts.forEach(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('[data-card-product]');
        if (card) grid.appendChild(card);
      });
      renderWishEmpty();
      initWishState();
      initQuickAddState();
    });
  }

  /* ---------- Zuletzt angesehen ---------- */
  var SEEN = 'amara:seen';

  function trackSeen() {
    var pdp = document.querySelector('[data-product-url]');
    if (!pdp) return;
    var url = pdp.getAttribute('data-product-url');
    if (!url) return;
    var list = store.get(SEEN, []).filter(function (u) { return u !== url; });
    list.unshift(url);
    store.set(SEEN, list.slice(0, 20));
  }

  function initRecent() {
    var mount = document.querySelector('[data-recent]');
    if (!mount || mount.dataset.ready) return;
    mount.dataset.ready = '1';

    var limit = parseInt(mount.getAttribute('data-limit') || '8', 10);
    var current = document.querySelector('[data-product-url]');
    var currentUrl = current ? current.getAttribute('data-product-url') : '';
    var list = store.get(SEEN, []).filter(function (u) {
      return u && u.split('?')[0] !== (currentUrl || '').split('?')[0];
    }).slice(0, limit);

    if (!list.length) return;
    var sec = mount.closest('[data-recent-sec]');

    Promise.all(list.map(function (u) {
      return fetch(u + (u.indexOf('?') > -1 ? '&' : '?') + 'section_id=card-product')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (parts) {
      var added = 0;
      parts.forEach(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('[data-card-product]');
        if (card) { mount.appendChild(card); added++; }
      });
      if (added > 0) {
        if (sec) sec.hidden = false;
        initCarousels(sec || document);
        initWishState();
        initQuickAddState();
      }
    });
  }

  function initQuickAddState() { initWishState(); }

  /* ---------- Adressen ---------- */
  function initAddresses() {
    document.querySelectorAll('[data-addr-toggle]').forEach(function (b) {
      if (b.dataset.ready) return;
      b.dataset.ready = '1';
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-addr-toggle');
        var form = document.querySelector('[data-addr-form="' + key + '"]');
        if (form) form.hidden = !form.hidden;
      });
    });

    document.querySelectorAll('[data-addr-delete]').forEach(function (b) {
      if (b.dataset.ready) return;
      b.dataset.ready = '1';
      b.addEventListener('click', function () {
        var url = b.getAttribute('data-addr-delete');
        if (!url) return;
        var f = document.createElement('form');
        f.method = 'post';
        f.action = url;
        f.style.display = 'none';
        var m = document.createElement('input');
        m.type = 'hidden'; m.name = '_method'; m.value = 'delete';
        f.appendChild(m);
        document.body.appendChild(f);
        f.submit();
      });
    });

    document.querySelectorAll('select[data-country][data-default]').forEach(function (sel) {
      var want = sel.getAttribute('data-default');
      if (want) sel.value = want;
    });

    initProvinces();
  }

  /* ---------- Adressen: Bundesland/Provinz zum Land ---------- */
  function initProvinces() {
    document.querySelectorAll('select[data-country]').forEach(function (sel) {
      if (sel.dataset.provReady) return;
      sel.dataset.provReady = '1';

      var scope = sel.closest('.cform__grid');
      if (!scope) return;
      var wrap = scope.querySelector('[data-province-wrap]');
      var prov = scope.querySelector('[data-province]');
      if (!wrap || !prov) return;

      var want = prov.getAttribute('data-default') || '';

      var sync = function () {
        var opt = sel.options[sel.selectedIndex];
        var list = [];
        try { list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (e) { list = []; }

        prov.innerHTML = '';
        if (!list.length) {
          wrap.hidden = true;
          prov.disabled = true;
          return;
        }
        wrap.hidden = false;
        prov.disabled = false;
        list.forEach(function (p) {
          var o = document.createElement('option');
          o.value = p[0];
          o.textContent = p[1];
          if (p[0] === want) o.selected = true;
          prov.appendChild(o);
        });
      };

      sel.addEventListener('change', function () { want = ''; sync(); });
      sync();
    });
  }

  /* ---------- Anmeldung: Passwort vergessen ---------- */
  function initLogin() {
    var login = document.querySelector('[data-login-box]');
    var recover = document.querySelector('[data-recover-box]');
    if (!login || !recover || login.dataset.ready) return;
    login.dataset.ready = '1';

    var show = function (which) {
      login.hidden = which === 'recover';
      recover.hidden = which !== 'recover';
    };
    document.querySelectorAll('[data-recover-open]').forEach(function (b) {
      b.addEventListener('click', function () { show('recover'); });
    });
    document.querySelectorAll('[data-recover-close]').forEach(function (b) {
      b.addEventListener('click', function () { show('login'); });
    });
    if (window.location.hash === '#recover') show('recover');
  }

  /* ---------- Newsletter ---------- */
  function initNewsletter() {
    document.querySelectorAll('.news__form').forEach(function (f) {
      if (f.dataset.ready) return;
      f.dataset.ready = '1';
      f.addEventListener('submit', function () {
        var ok = f.querySelector('[data-news-ok]');
        if (ok) window.setTimeout(function () { ok.hidden = false; }, 400);
      });
    });
  }

  /* ---------- Produkt-Empfehlungen ---------- */
  function initRecos() {
    document.querySelectorAll('[data-recos]').forEach(function (box) {
      if (box.dataset.loaded || !box.dataset.url) return;
      box.dataset.loaded = '1';
      fetch(box.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recos]');
          if (fresh && fresh.innerHTML.trim()) {
            box.innerHTML = fresh.innerHTML;
            initCarousels(box);
            initWishState();
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Start ---------- */
  function boot() {
    trackSeen();
    initCarousels();
    initAnnouncement();
    initHeaderScroll();
    initMobileNav();
    initFacets();
    initLoadMore();
    initSearch();
    initVariants();
    initQty();
    initGallery();
    initStickyBar();
    initSizeGuide();
    initShare();
    initWish();
    initWishPage();
    initRecent();
    initAddresses();
    initLogin();
    initNewsletter();
    initRecos();
    Cart.init();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    initCarousels(e.target);
    initAnnouncement();
    initHeaderScroll();
    initFacets();
    initLoadMore();
    initSearch();
    initVariants();
    initQty();
    initGallery();
    initStickyBar();
    initSizeGuide();
    initShare();
    initWish();
    initWishPage();
    initRecent();
    initAddresses();
    initLogin();
    initNewsletter();
    initRecos();
  });
})();
